import { redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/lib/auth-store';

/**
 * Used in beforeLoad of protected routes. Reads the auth store synchronously
 * and throws a redirect to /login if no session is available.
 *
 * Note on `location.search`: TanStack Router passes search as a parsed object
 * (Record<string, unknown>), not as a query string. We only persist
 * `location.pathname` as the redirect target — losing the query string is
 * acceptable for re-routing after login, and avoids the
 * "Cannot convert object to primitive value" TypeError from concatenating.
 */
export function requireAuth({
  location,
}: {
  location: { pathname: string };
}): void {
  const { accessToken, refreshToken, orgSlug } = useAuthStore.getState();
  if (!orgSlug || (!accessToken && !refreshToken)) {
    throw redirect({
      to: '/login',
      search: { redirect: location.pathname },
    });
  }
}
